(function() {
  'use strict';

  angular
    .module('in-out-rm')
    .controller('mentorshipController', mentorshipController);

  mentorshipController.$inject = ['$scope','sidetopHttp','$http','$timeout','getMentorshipMentorId','getMentorshipIsMentee',
    '$interval','$state','$window','$rootScope','asMessages','adminRights','$filter','contentApprovalAccessMsg','analytics','features','fileDownload'];
  function mentorshipController($scope,sidetopHttp,$http,$timeout,getMentorshipMentorId,getMentorshipIsMentee,
    $interval,$state,$window,$rootScope,asMessages,adminRights,$filter,contentApprovalAccessMsg,analytics,features,fileDownload) {
    
    //variables
    $scope.s3base = s3base;
    $scope.myUid = $rootScope.app_data.uid; //rootscope
    $scope.myCid = $rootScope.app_data.cid; //rootscope
    $scope.API_BASE_URL = $window.API_BASE_URL;
    $scope.instituteName = $rootScope.app_data.data.name;

    $scope.mentorId = 0;  //give mentor-id or zero
    $scope.mentorInfo = null;
    $scope.isMentee = false;    //check if user have ever tried to be mentee

    $scope.pageError = null;
    $scope.pageMessage = null;

    $scope.stream = 1;
    $scope.limit = 10;
    $scope.no_more_mentors = false;
    $scope.mentorsListShow = false;
    $scope.mentorsList = [];          // 8 - showTab
    
    $scope.currentListShow = false;   // 6 - showTab
    $scope.requestsListShow = false;  // 7 - showTab    
    $scope.currentList = [];
    $scope.currentListLoad = false;    // 6 -
    $scope.requestsList = [];
    $scope.requestsListLoad = false;    // 7 - 

    $scope.menteeMessage = '';
    $scope.newMentee = false;
    $scope.beMenteeOfMentor = null;
    $scope.becomingMenteeLoading = false;

    //used for front-end
    $scope.showDrawer = false;
    $scope.isSmallDisplay = false;
    if(window.innerWidth < 480){
      $scope.isSmallDisplay = true;
    }

    //function bindings
    $scope.getMentorInfo = getMentorInfo;
    $scope.showTab = showTab;

    $scope.fetchMentorships = fetchMentorships;
    $scope.loadMentors = loadMentors;
    $scope.filterMentorsByStatus = filterMentorsByStatus;

    $scope.updateMenteeStatus = updateMenteeStatus;  
    $scope.updateMentorStatus = updateMentorStatus;

    $scope.enableNewMentorship = enableNewMentorship;
    $scope.disableNewMentorship = disableNewMentorship;
    $scope.askForMentorship = askForMentorship;
    $scope.adjustMentorship = adjustMentorship;
    $scope.tickPreference = tickPreference;
    $scope.savePreferences = savePreferences;
    $scope.provideMentorship = provideMentorship;
    $scope.removeAsMentor = removeAsMentor;
    $scope.downloadMentorList = downloadMentorList;
    $scope.mentor_update_message = mentor_update_message;
    //variable for front-end
    $scope.showtickmark1 = false;
    $scope.showtickmark2 = false;
    $scope.menteeMessageShowError = false;
    $scope.roleSubmitted = false;

    //functions at front-end
    $scope.rolementor = rolementor;
    $scope.rolementee = rolementee;
    $scope.rolesubmit = rolesubmit;

    $scope.adminRights=adminRights.isAllowed;

    $scope.mentor_status = {
      1 : 'Accepted Requests',
      0 : 'Pending Requests',
      2 : 'Rejected Requests',
      3 : 'Show All Mentors'
    };
    $scope.mentor_status_key = 1;
    //actiivate
    activate();

    function activate() {
      $scope.preferences = {
        all: [
          'Higher Studies',
          'Career Advice',
          'Personal Guidance'
        ],
        mentor: [],
        mentee: []
    };

      //mentro
      var response = getMentorshipMentorId.data;
      if(response.success != 1){
        if(response.success == -1){
          $scope.mentorId = 0;
          // user is not a mentor
        }
        else{
          try{
            $scope.pageMessage = response.data.message;  
            $scope.pageError = response.data.error;
          }
          catch(e){}
        }
      }//user is mentee
      else{
        add_user_as_mentor();
        $scope.mentorId = response.data.mentor.id;
        $scope.getMentorInfo();
      }

      // mentee
      response = getMentorshipIsMentee.data;
      if(response.success != 1){
        if(response.success == -1){
          $scope.isMentee = false;
          // user is not a mentee
        }
        else{
          try{
            $scope.pageMessage = response.data.message;  
            $scope.pageError = response.data.error;
            $scope.isMentee = false;
          }
          catch(e){}
        }
      }//user is mentee
      else{
        $scope.isMentee = true;
        try{
          $scope.menteePreferences = response.data.mentee.meta_value.split(',');
        }catch(e){}
      }

      // if($scope.mentorId != 0 || $scope.isMentee) $scope.showTab(6);
      // else $scope.showTab(8);
      $scope.showTab(8);        
      
      $scope.isMobile=mobile_web_tab.isMobile;
      angular.element($window).on('resize', function () {
          $scope.isSmallDisplay = false;
            if(window.innerWidth < 480){
              $scope.isSmallDisplay = true;
            }
      });
      
      $scope.$on('$destroy', function () {
        angular.element($window).on('resize');
      });
      $window.onbeforeunload = function(){
        $scope.$destroy();
      };
    }


    function getMentorInfo(){

        var data ={
          mentor_id: $scope.mentorId
        };

        return sidetopHttp.postDataCall('./mentorship/mentorship/get_mentor',data,function(response) {
          if (response.success == 1) {
              $scope.mentorInfo = response.data.mentor;
              var userType = 'user';
              if($scope.myUid==response.data.mentor.mentor_user_basic_id)
                  userType = 'poster';
              else if($rootScope.app_data.isAdmin)
                  userType = 'admin';

              $scope.mentorInfo.approvalStatusData = {
                'userType':userType,
                'featureName':'Mentorship',
                'approvalStatus':response.data.mentor.state,
                'approverUui':response.data.mentor.approver_uui,
                'cas_obj':{'cas_id':response.data.mentor.id}
              };
              add_user_as_mentor($scope.mentorInfo);
          }
          else{
              try{
                $scope.pageMessage = response.data.message;
                $scope.pageError = response.data.error;  
              }
              catch(e){

              }
          }
        });
    }


    function showTab(tab_id){
      
      $scope.currentListShow = false;      // 6 - showTab
      $scope.requestsListShow = false;      // 7 - showTab
      $scope.mentorsListShow = false;       // 8- showTab

      if(tab_id == 6){
        $scope.currentListShow = true;    // 6 - showTab
        $scope.fetchMentorships( [1] );   //status = 1 => accepted/current threads/mentorships
      }
      else if(tab_id == 7){
        $scope.requestsListShow = true;    // 7 - showTab
        $scope.fetchMentorships( [0, 2] );   //status = 0,2 => pending or rejected mentorships
      }
      else if(tab_id == 8){
        $scope.mentorsListShow = true;    // 8 - showTab
        $scope.loadMentors();   
      }

      if($scope.isSmallDisplay == true){
        $scope.showDrawer = false;  
      }
      
    }


    function fetchMentorships(statuses) {
        var url = "./mentorship/mentorship/fetch_all_mentorships";
        var data = {
            mentee_statuses: statuses
        };

        if(statuses.length == 2 && $scope.requestsListLoad == false){   // array-length 2 assumes it is requesting for pending and rejected mentorships
            return sidetopHttp.postDataCall(url,data,function(response) {
              if (response.success == 1) {
                  $scope.requestsList = response.data.mentorships;
                  $scope.requestsListLoad = true;
                  if($scope.requestsList.length == 0){
                    $scope.pageMessage = "No pending or rejected Mentorships";
                  }
              }
              else{
                  try{
                    $scope.pageMessage = response.data.message;
                    $scope.pageError = response.data.error;  
                  }
                  catch(e){

                  }
              }
            });
        }

        else if(statuses.length == 1 && $scope.currentListLoad == false){   // array-length 1 assumes it is requesting for approved mentorships
            return sidetopHttp.postDataCall(url,data,function(response) {
              if (response.success == 1) {
                  $scope.currentList = response.data.mentorships;
                  $scope.currentListLoad = true;
                  if($scope.currentList.length == 0){
                    $scope.pageMessage = "No active mentorship threads found.";
                  }
              }
              else{
                  try{
                    $scope.pageMessage = response.data.message;
                    $scope.pageError = response.data.error;  
                  }
                  catch(e){

                  }
              }
            });
        }
    }

    function filterMentorsByStatus(status){
      if($scope.mentor_status_key == status) return;
      $scope.mentor_status_key = status;
      $scope.stream = 1;
      $scope.loadMentors(1);
    }



    //status - 1=>accept, 2=>reject
    function updateMenteeStatus(mentee, status){
        var url = "./mentorship/mentorship";
        if(status == 1){
          url = url + "/accept_mentorship";
        }
        else if(status == 2){
          url= url + "/reject_mentorship";
        }

        var data = {
          mentee_id: mentee.mentee_id
        };

         return sidetopHttp.postDataCall(url,data,function(response) {
            if (response.success == 1) {
                
                //get posotion in array
                var index_array = -1;
                for (var i2 = $scope.requestsList.length - 1; i2 >= 0; i2--) {
                  if($scope.requestsList[i2].mentee_id == mentee.mentee_id){
                    index_array = i2;
                    break;
                  }
                }

                if(status == 1){
                  $scope.pageMessage = "You can start mentoring " + mentee.mentee_first_name + " now.";
                  
                  $scope.requestsList.splice(index_array, 1);
                  
                  mentee.mentee_status = status.toString();  //accepted status
                  $scope.currentList.unshift(mentee);  //add at the beggining of array   
                }
                else if(status == 2){
                  $scope.pageMessage = "Mentorship request rejected successfully.";
                  $scope.requestsList[index_array].mentee_status = status.toString();      //now in rejected state
                }
                snackbar_general($scope.pageMessage, 3500);
            }
            else{
                try{
                  $scope.pageMessage = response.data.message;
                  $scope.pageError = response.data.error;  
                }
                catch(e){

                }
            }
          });
      }


    //functions
    function loadMentors(status){

        if(status)
           $scope.no_more_mentors = false; 
        if($scope.no_more_mentors == false && !$scope.loading_mentors){//load only if end-of-list not reached
  
          $scope.loading_mentors = true;
          var data ={
            stream: $scope.stream,
            limit: $scope.limit,
            cid: $scope.myCid
          };
          if(adminRights.isAllowed(2)){
            if($scope.mentor_status_key!=3){
              data.approved = [$scope.mentor_status_key];
            }
            else{
              data.approved = [0,1,2];
            }
          } 
          if(data.stream==1 && status){
            if($scope.mentorInfo!=null){
              $scope.mentorsList.splice(1);
            }else{
              $scope.mentorsList = [];
            }
          }

          return sidetopHttp.postDataCall('./mentorship/mentorship/get_mentors',data,function(response) {
            $scope.loading_mentors = false;
            if (response.success == 1) {
                var userType = 'user';
                for (var i = 0; i < response.data.mentors.length; i++) {
                    userType = 'user';
                    if($scope.myUid==response.data.mentors[i]['mentor_user_basic_id'])
                      userType = 'poster';
                    else if($rootScope.app_data.isAdmin)
                      userType = 'admin';                    
                    var approvalStatusData = {
                      'userType':userType,
                      'featureName':'Mentorship',
                      'approvalStatus':response.data.mentors[i].state,
                      'approverUui':response.data.mentors[i].approver_uui,
                      'cas_obj':{'cas_id':response.data.mentors[i].id}
                    };
                    $scope.mentorsList.push(response.data.mentors[i]);
                    $scope.mentorsList[$scope.mentorsList.length - 1].approvalStatusData = approvalStatusData;
                    //$scope.mentorsList.indexOf(response.data.mentors[i])
                }
                if( response.data.mentors.length == $scope.limit ){
                    $scope.stream = $scope.stream + 1;
                    $scope.no_more_mentors = false;
                }
                else{
                    $scope.no_more_mentors = true;
                }
            }
            else if(response.success == 10)
            {
                $scope.no_more_mentors = true;
            }
            else{
                try{
                  $scope.pageMessage = response.data.message;
                  $scope.pageError = response.data.error;  
                }
                catch(e){}
            }
            as_upgrade(100);
          });
        }

    }


    function askForMentorship(){

        var url = "./mentorship/mentorship";
        var data = {};
        if($scope.beMenteeOfMentor.mentee_id != null && $scope.beMenteeOfMentor.mentee_status == 2){
          url =url + "/update_mentee_message";
          data ={
            mentee_id: $scope.beMenteeOfMentor.mentee_id,
            message: $scope.menteeMessage
          };
        }
        else if($scope.beMenteeOfMentor.mentee_id == null){
          url = url + "/new_mentee";
          data ={
            mentor_id: $scope.beMenteeOfMentor.mentor_id,
            message: $scope.menteeMessage
          };
        }
      
        return sidetopHttp.postDataCall(url,data,function(response) {
          if (response.success == 1) {
              $scope.isMentee = true;
              var mentee_status = 0;

              $scope.pageMessage = "Request has been sent to mentor.";
              snackbar_general($scope.pageMessage, 3500);

              $scope.beMenteeOfMentor.mentee_message = $scope.menteeMessage;
              $scope.beMenteeOfMentor.mentee_status = mentee_status.toString();      //now in pending state
              $scope.beMenteeOfMentor.mentee_time = Math.floor(Date.now() / 1000).toString();

              //requestList Adjustment/removal
              //remove old-one,if exist
              if($scope.beMenteeOfMentor.mentee_id != null){
                  for (var i2 = $scope.requestsList.length - 1; i2 >= 0; i2--) {
                    if($scope.requestsList[i2].mentee_id == $scope.beMenteeOfMentor.mentee_id){
                      var removedObject = $scope.requestsList.splice(i2,1);
                      removedObject = null;
                      break;
                    }
                  }
              }
              //do adjustments into mentorsList
              $scope.adjustMentorship(response.data.mentee_id);

              //add new one into requestList
              $scope.beMenteeOfMentor.mentee_id = response.data.mentee_id.toString();
              $scope.beMenteeOfMentor.mentee_user_basic_id = $scope.myUid;
              $scope.requestsList.unshift($scope.beMenteeOfMentor);   //add at the beggining of array
              
              $scope.disableNewMentorship();
          }
          else{
              try{
                $scope.pageMessage = response.data.message;
                $scope.pageError = response.data.error;  
              }
              catch(e){

              }
          }
        });
    }


    function enableNewMentorship(mentor, event){
        // $scope.newMentee = true;
        // $scope.menteeMessage = '';
        // $scope.beMenteeOfMentor = mentor;
        send_mentorship_message(mentor, event);
    }


    function disableNewMentorship(){
        $scope.newMentee = false;
        $scope.menteeMessage = '';
        $scope.beMenteeOfMentor = null;
        $scope.menteeMessageShowError = false;
    }


    function send_mentorship_message(mentor, event){
        // send a message to mentor on befalf of the mentee
        // use portal's messaging service
        var user = {
          name: mentor.mentor_first_name + ' ' + mentor.mentor_last_name,
          uui: mentor.mentor_unique_user_id,
          uid: mentor.mentor_user_basic_id
        };
        var msg;
        var custom_message = features.getFeature("mentorship.custom_message");
        if(custom_message){
          msg = custom_message;
          msg = msg.replace("[Name]", mentor.mentor_first_name + ' ' + mentor.mentor_last_name);
          msg = msg.replace(/<br>/g, "\n");
          msg = msg.replace(/<br \/>/g, "\n");
        }
        else{
        msg = "Hi, " + mentor.mentor_first_name + ' ' + mentor.mentor_last_name;
        msg += "\nI am looking for a mentor and your profile matches with what I am looking for.";
        msg += "\nWe both belong to this same community and your expertise can help me out here.";
        msg += "\n\nIt will be great pleasure to get guidance from you.";
        msg += "\nThanking you,\n" + $rootScope.app_data.name;
        }
        var params = {
          heading: "Send Mentorship Message",
          hideChips: true,
          defaultMessage: msg,
          messageSourceAndContextNeeded : {source:"Mentorship", context:mentor.mentor_id},
          sendMessageCallback: function(res) {
            if(res && res.success==1)
              analytics.event('Mentorship,Send request button,Message sent');
          }
        };
        asMessages.openSendBox(user, event.target, function() {
          //dummyfunction
        }, params);
    }

    function add_user_as_mentor(mentor_found){
      var mentor = null;
      for (var i = $scope.mentorsList.length - 1; i >= 0; i--) {
        mentor = $scope.mentorsList[i];
        if(mentor.mentor_user_basic_id == $scope.myUid){
          if(mentor_found) $scope.mentorsList[i] = mentor_found;
          break;
        }
      } // completed finding the mentor
      
      if(mentor == null){
        mentor = {
          mentees_count: 0,
          mentor_available: 0,
          mentor_available_from_date: 0,
          mentor_batch_end: 0,
          mentor_batch_start: 0,
          mentor_degree: "",
          mentor_department: "",
          mentor_specialization: "",
          mentor_institute: "",
          mentor_first_name: $rootScope.app_data.name,
          mentor_id: null,
          mentor_last_name: "",
          mentor_message: "",
          mentor_role: 0,
          mentor_sectors: null,
          mentor_unique_user_id: 0,
          mentor_user_basic_id: $rootScope.app_data.uid,
          profile_pic: $rootScope.app_data.profile_pic,
          mentor_approved_status: 0,
          approvalStatusData : {
            'userType' : 'user',
            approvalStatus: null,
            featureName : 'Mentorship',
            cas_obj : {'cas_id': null}
          }
        };
        var user = $rootScope.app_data.logged_user_roles[0];
        if(user){
          mentor.mentor_batch_end = user.end;
          mentor.mentor_batch_start = user.start;
          mentor.mentor_degree = user.degree;
          mentor.mentor_department = user.department;
          mentor.mentor_specialization = user.specialization;
          mentor.mentor_institute = user.institute;
          mentor.mentor_role = user.role;
          mentor.mentor_unique_user_id = user.id;
        }
        $scope.mentorsList.push(mentor);
      }
    }


    function adjustMentorship(mentee_id){
        
        //status will alway be pending/0 after new/re-submitting mentorship request
        
        for (var i2 = $scope.mentorsList.length - 1; i2 >= 0; i2--) {
            var mentee_status = 0;
            if($scope.mentorsList[i2].mentor_id == $scope.beMenteeOfMentor.mentor_id){
              $scope.mentorsList[i2].mentee_id = mentee_id;
              $scope.mentorsList[i2].mentee_status = mentee_status.toString();
              $scope.mentorsList[i2].mentee_time =  Math.floor(Date.now() / 1000).toString();
              break;
            }
        }
    }

    function tickPreference(pref, list){
      if($rootScope.app_data.loginStatus != 1){
        $state.go('inapp.login', {redirect: './mentorship'});
      }
      var found = list.indexOf(pref);
      if(found > -1) list.splice(found,1);
      else list.push(pref);
    }

    function savePreferences(role,event){
      if($rootScope.app_data.loginStatus != 1){
        $state.go('inapp.login', {redirect: './mentorship'});
      }
      else if (role == "mentor"){
        $scope.new_mentor_form = true;
        if($scope.preferences.mentor.length == 0) return;
        $scope.provideMentorship({extra_params: {mentorPreferences: $scope.preferences.mentor}},event);
      }
      else if(role == "mentee"){
        $scope.new_mentee_form = true;
        if($scope.preferences.mentee.length == 0) return;
        saveNewMenteePreferences($scope.preferences.mentee);        
      }
    }

    function saveNewMenteePreferences(preferences){
      if(!preferences || preferences.length == 0) return;
      if($scope.becomingMenteeLoading) return;
      $scope.becomingMenteeLoading = true;
      var data = { preferences: preferences }; 
      return sidetopHttp.postDataCall('./mentorship/mentorship/set_mentee_preferences',data,function(response) {
        if (response.success == 1) {
            direct_to_profile_completion();
        }
        else{
            $scope.becomingMenteeLoading = false;
            try{
              console.log('Mentee preferences',response.data);
              $scope.pageMessage = response.data.message;
              $scope.pageError = response.data.error;  
            }
            catch(e){}
        }
      });
    }

    function direct_to_profile_completion(){
      var allowedFor = {
        'skills': {
          'reason': 'Let mentors know about your '+$filter('asLingo')('42')
        },
        'photo': {
          'reason': 'Let mentors recognize you in the Directory.'
        }
      };

      $state.go('inapp.extra_info', {
        fields: 'skills,work,education,photo',
        pref: 'noSocial',
        removeHeader: false,
        extra_params: {
          redirect: "inapp.mentorship",
          allowedFor: allowedFor
        }
      });
    }


    //front-end functions
    //
    function rolementor() {
      $scope.showtickmark1 = true;
      $scope.showtickmark2 = false;
    }

    function rolementee() {
      $scope.showtickmark1 = false;
      $scope.showtickmark2 = true;

    }

    function rolesubmit() {
      $scope.roleSubmitted = true;

      if ($scope.showtickmark1 === true) {
        $scope.provideMentorship();
      }

      else if($scope.showtickmark2 === true) {
        $scope.showTab(8); 
      }

    }

    function sendMessageCallback(){
      console.log('here');
      updateMentorStatus($scope.mentor_stats,$scope.mentor_info,$scope.mentor_event);
    }

    // Not in use now
    /*Author : Virendra Pratap*/
    function mentor_update_message(status,mentor,event){
        
        $scope.mentor_stats = status;
        $scope.mentor_info = mentor;
        $scope.mentor_event = event;

        var user = {
          name: mentor.mentor_first_name + ' ' + mentor.mentor_last_name,
          uui: mentor.mentor_unique_user_id,
          uid: mentor.mentor_user_basic_id
        };
        var msg = "Hi, " + mentor.mentor_first_name + ' ' + mentor.mentor_last_name;
        if(status == 2) msg += "\nWe are sorry. You profile do not match our criteria for a mentor and therefor you request to become a mentor can not be approved.";
        if(status == 1) msg += "\nCongratulations your request to become a mentor has been approved. Now onwards mentees will be able to find and approach you easily.";
        msg += "\n\nThanking you,\n" + $rootScope.app_data.name;
        var heading = status == 2 ? 'Send Rejection Message' : 'Send Approval Message';
        var params = {
          heading: heading,
          hideChips: true,
          defaultMessage: msg,
          sendMessageCallback:sendMessageCallback
        };
        asMessages.openSendBox(user, event.target, function() {
          //dummyfunction
        }, params);
        
    }
    //status - 1=>accept, 2=>reject
    /*Author : Virendra Pratap*/
    function updateMentorStatus(status,mentor){
      if(!adminRights.isAllowed(2)) return;
      var url = "./mentorship/mentorship";
      if(status == 1) url += "/approve_mentor";
      else if(status == 2) url += "/reject_mentor";
      var data = {
         mentor_id: mentor.mentor_id
      };
      return sidetopHttp.postDataCall(url,data,function(response){
          if(response.success == 1){
            mentor.mentor_approved_status = status;
            if(status == 1)
              snackbar_general("Profile Approved Successfully.", 3500);
            else
              snackbar_general("Profile Rejected Successfully.",3500);
          }
      });
    }

    function provideMentorship(params,event) {
      if(!params) params = {};
      if(!$scope.mentorId && chk_restrictions_return(48)){
         contentApprovalAccessMsg.showModel();
      }
      else
        $state.go('inapp.newmentor', params);
    }

    function removeAsMentor(mentorship,index) {
      var title_v = "Remove as mentor";
      var text_v = "Are you sure want to remove this user as a mentor?";
      if(mentorship.mentor_user_basic_id == $scope.myUid){
        title_v = "Remove myself as mentor";
        text_v = "Are you sure want to remove yourself as a mentor? You will be removed from the mentors list.";
      }
      swal({ 
          title: title_v,
          text: text_v,
          buttons: ['No, Cancel', {text: 'Yes, Remove',closeModal:false}]
      }).then(function(isConfirm) {
          if (isConfirm) {
            var data = {
              mentor_id: mentorship.mentor_id
            };
            $http.post('./mentorship/mentorship/removeAsMentor', data).success(function(res) {
              if (res.success == 1) {
                swal.stopLoading();
                swal.close();
                snackbar_general('Removed as a mentor successfully.', 3000);
                $scope.mentorsList.splice(index, 1);
              }
            });
          }
      });
    }

    function downloadMentorList(){
      var url = $rootScope.api_base+'mentorship/download_mentors_list';
      fileDownload.do(url,'csv');
    }
  }



}());
